import dot from 'dot/doT';
import BaseFilter from './baseFilter';
import $ from 'jquery';
import template from '../../views/filterblocks/radios.dot';
const templateFunction = dot.template(template);

const CLASSES = {
    entered: 'input--entered',
};

export default class RadioInput extends BaseFilter {
    constructor(parentEl, options = {}) {
        super(options);
        this.parentEl = parentEl;
        this.options = $.extend({}, options);
        this._drawRadio();
    }
    _drawRadio() {
        const renderedTemplate = $(templateFunction(this.options));
        this.inputEl = renderedTemplate.find('input');
        this.inputEl.click(this._onChangeEvent.bind(this));
        this.parentEl.append(renderedTemplate);
        this.el = renderedTemplate;
        this.setupCloseApplyButtons();
        if (this.options.initialSelection) {
            this._currentValue = {
                label: this.options.options[this.options.initialSelection],
                value: this.options.initialSelection,
                radio: this
            };
        }
        else {
            this._markElementSelected(this.el.find('.all-option'));
        }
    }
    _onChangeEvent(e) {
        const val = $(e.target).val();
        const label = $(e.target).parents('.input').find('.input__label').text();
        if (this._currentValue && this._currentValue.value == val) {

            var allVal = $(this.inputEl[0]).val();
            var allLabel = $(this.inputEl[0]).parents('.input').find('.input__label').text();
            this._currentValue = {
                label: allLabel,
                value: allVal,
                inputEl: $(this.inputEl[0]),
                radio: this
            };
            this._markElementSelected( $(this.inputEl[0]));
        }
        else  {
            this._markElementSelected($(e.target));
            this._currentValue = {
                label: label,
                value: val,
                inputEl: $(e.target)
            };
        }
        if (this.options.onChangeEvent) {
            this.options.onChangeEvent(this._currentValue);
        }
    }
    _markElementSelected(element) {
        this.el.find(`.${CLASSES.entered}`).removeClass(CLASSES.entered);
        element.parents('.input').addClass(CLASSES.entered);
        element.attr('checked', '');
    }
    get currentValue() {
        return this._currentValue;
    }
    unselect($element) {
        $element.prop('checked', false);
        $element.parents('.input').removeClass(CLASSES.entered);
    }

    getInputElFromValue(value) {
        return this.inputEl.filter(function (i, el) { return el.value === value; });
    }
}
